import React from "react";
import { FeatureCallback } from "./types";
import { useFeature } from "./use-feature";

type Props = {
  children: ((enabled: FeatureCallback) => React.ReactNode) | React.ReactNode;
}

export const FeatureFlag: React.FC<Props> = (props) => {
  const enabled = useFeature();

  switch (typeof props.children) {
    case "function":
      return (props.children as CallableFunction)(enabled);
    default:
      return props.children;
  }
};
